import React, { useEffect } from 'react';
import { Header, Title, Wrapper } from './list-product-manager-requests.styles';
import { ArrowsChevronRight } from '@vtbhome/juicyfront/indexIcon';
import { ROUTE_ADMIN_APPROVE_REQUESTS } from '@shared/config/routes/routes';
import { COLORS } from '@shared/config/colors/colors';
import { Typography } from '@shared/ui/typography/typography';
import { useRequestsListSharedQuery } from '@entities/request/libs/hooks/use-request-list-shared-query/use-request-list-shared-query';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { ListShortApprovalManagerRequest } from '@widgets/list-short-approval-manager-requests/ui/list-short-approval-manager-requests';
import { DEFAULT_REQUESTS_LIST_PARAMETERS } from '@entities/request/config/store-constants';
import { RequestsListDataRequest } from '@entities/request/api/request-types';
import { RequestStatus } from '@shared/model/request';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';
import { LinkScroll } from '@shared/ui/link-scroll/link-scroll';

export const ListProductManagerRequests: React.FC = () => {
    const user = useCurrentUserSelector();
    const [requestsListParameters, setRequestsListParameters] = useSearchParams<RequestsListDataRequest>({
        ...DEFAULT_REQUESTS_LIST_PARAMETERS,
        companyId: user?.company?.id || undefined,
        statuses: RequestStatus.New,
    });
    const [getRequests] = useRequestsListSharedQuery(requestsListParameters);

    useEffect(() => {
        getRequests(requestsListParameters);
    }, [requestsListParameters]);

    return (
        <Wrapper>
            <Header>
                <Title>
                    <Typography size='h6'>Запросы к согласованию</Typography>
                </Title>
                <LinkScroll to={`${ROUTE_ADMIN_APPROVE_REQUESTS}`}>
                    <ArrowsChevronRight color={COLORS.neutral_50} />
                </LinkScroll>
            </Header>
            <ListShortApprovalManagerRequest
                requestsListParameters={requestsListParameters}
                setRequestsListParameters={setRequestsListParameters}
            />
        </Wrapper>
    );
};
